import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {TechDocZipRequest} from '../models';

@Injectable()
export class TechDocZipRequestService extends IoService {
  protected model = TechDocZipRequest;
  protected listUrl = '/pdfs-zip/';
}
